import { UseFormReset } from 'react-hook-form';

import { WAITING_TIME } from 'coreOld/constants';
import { useUomsActions } from 'partsOld/hooks';
import { ICompanyPart, IUom, IUomForm } from 'partsOld/types';

import UomConversionFormView from './UomConversionFormView';

interface IProps {
  isAddOpen: boolean;
  closeModal: (reset) => void;
  onRemove: (reset?) => Promise<void>;
  onCancelRemove: () => void;
  part: Partial<ICompanyPart>;
  selectedItem?: IUomForm;
  removedItem?: IUomForm;
}

const UomConversionForm = ({
  isAddOpen,
  closeModal,
  selectedItem,
  removedItem,
  onRemove,
  onCancelRemove,
  part,
}: IProps) => {
  const { upsertUomConversion } = useUomsActions();

  const onSubmit = (reset: UseFormReset<IUom>) => async (data: IUom) => {
    try {
      let dataToSend;

      if (data?.id) {
        dataToSend = data;
      } else {
        dataToSend = {
          ...data,
          manufacturerId: part.manufacturerId,
          part: part.part,
        };
      }

      await upsertUomConversion(dataToSend);

      setTimeout(() => closeModal(reset), WAITING_TIME);
    } catch (err) {}
  };

  return (
    <UomConversionFormView
      onSubmit={onSubmit}
      isAddOpen={isAddOpen}
      closeModal={closeModal}
      selectedItem={selectedItem}
      removedItem={removedItem}
      onRemove={onRemove}
      onCancelRemove={onCancelRemove}
    />
  );
};

export default UomConversionForm;
